/**
 * A helper that determines if the locale has a 12H time format. If provided with anything else than a string with a
 * length of at least 2, it will fall back to 'en-GB'.
 *
 * @param {string} locale - language code from intl.getLocale()
 * @returns {boolean} -
 */
export function isAmPm(locale) {
    locale = locale && typeof locale === 'string' && locale.trim().length > 1 ? locale : 'en-GB'
    return /([ap])\.?m\.?/i.test(new Date().toLocaleTimeString(locale))
}
